(() => {
  'use strict';

  const COPIED_DURATION_MS = 2000;
  const SELECTOR = '.js-promo-cta-copy';

  function copyViaExecCommand(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  }

  function copyPromoCode(text) {
    if (!text) return Promise.resolve(false);

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard
        .writeText(text)
        .then(() => true)
        .catch(() => Promise.resolve(copyViaExecCommand(text)));
    }

    return Promise.resolve(copyViaExecCommand(text));
  }

  function showCopied(button) {
    if (!button || button.classList.contains('is-copied')) return;

    button.classList.add('is-copied');
    window.setTimeout(() => {
      button.classList.remove('is-copied');
    }, COPIED_DURATION_MS);
  }

  function onCopyClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const code = (button.dataset.promoCode || '').trim();
    if (!code) return;

    copyPromoCode(code).then((ok) => {
      if (ok) showCopied(button);
    });
  }

  function bindCopyButtons(root = document) {
    root.querySelectorAll(SELECTOR).forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      if (button.dataset.promoCtaCopyBound === 'true') return;
      button.dataset.promoCtaCopyBound = 'true';
      button.addEventListener('click', onCopyClick);
    });
  }

  function init() {
    bindCopyButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) bindCopyButtons(event.target);
  });
})();
